import React from 'react';
import {StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';

import {backgroundMetricsAlertScreen} from '../../assets/images';
import {Button} from '../../components/Button';
import {Text} from '../../components/Typography';
import {Messages} from '../../constants/Strings';
import {Strings} from '../../constants/Strings';
import {Navigators, Screens} from '../../constants/navigation';
import {useBackPress} from '../../lib/hooks/useBackPress';
import {useBreakpoints} from '../../lib/hooks/useBreakpoints';
import {
  appSettingsSelector,
  updateAppSettings,
} from '../../lib/redux/slices/appSettingsSlice';
import {useAppDispatch} from '../../lib/redux/useAppDispatch';
import {responsive} from '../../lib/utils';
import type {RootStackScreenProps} from '../../navigators/RootStackNavigator';
import {RedirectionParameter} from '../../navigators/params';
import {centerText} from '../../styles';
import {TermsAndPrivacy} from '../components';
import {
  BodyContainer,
  ContentContainer,
  FlexImage,
  Footer,
  ImageContainer,
  Layout,
  TitleContainer,
} from '../components/composable';

interface ScreenProps extends RootStackScreenProps<typeof Screens.ValueProp> {}

export const ValuePropScreen: React.FC<ScreenProps> = ({navigation}) => {
  const {isMedium} = useBreakpoints();

  const dispatch = useAppDispatch();

  const {agreeAgreement} = useSelector(appSettingsSelector);

  const agreeTerms = () => {
    if (agreeAgreement) return;

    dispatch(updateAppSettings({agreeAgreement: true}));
  };

  useBackPress(() => {
    navigation.goBack();
    return true;
  });

  return (
    <Layout>
      <ImageContainer>
        <FlexImage source={backgroundMetricsAlertScreen} />
      </ImageContainer>

      <ContentContainer>
        <BodyContainer>
          <TitleContainer>
            <Text style={centerText} variant="h2">
              {Messages.VALUE_PROPS.title}
            </Text>
          </TitleContainer>

          <Text variant="description" style={[styles.description, centerText]}>
            {Messages.VALUE_PROPS.subtitle}
          </Text>

          <Text variant="description" style={centerText}>
            {Messages.VALUE_PROPS.body}
          </Text>
        </BodyContainer>

        <Footer>
          <Button
            onPress={() => {
              agreeTerms();

              navigation.navigate(Screens.Register, {
                redirect: new RedirectionParameter(Navigators.MainNavigator, {
                  screen: Screens.BluetoothStartPairing,
                }).encode(),
                canSkip: true,
              });
            }}>
            {Messages.CREATE_ACCOUNT_BTN}
          </Button>

          <Button
            variant="secondary"
            onPress={() => {
              agreeTerms();

              navigation.navigate(Screens.Login, {
                redirect: new RedirectionParameter(Navigators.MainNavigator, {
                  screen: Screens.BluetoothStartPairing,
                }).encode(),
                canSkip: true,
              });
            }}>
            {Strings.SIGN_IN}
          </Button>

          <Text variant={isMedium ? 'xs' : 's'} style={centerText}>
            {Messages.LEGAL_AGREEMENT} <TermsAndPrivacy />
          </Text>
        </Footer>
      </ContentContainer>
    </Layout>
  );
};

const styles = StyleSheet.create({
  description: {
    marginBottom: responsive(32),
  },
});
